export const STATUS_CONFIG = {
  frio: { label: 'Frío', color: '#64748b', bg: 'rgba(100,116,139,0.15)' },
  contactado: { label: 'Contactado', color: '#2E7DE2', bg: 'rgba(46,125,226,0.15)' },
  // El seguimiento de los prospectos que no contestaron (ver estadosPara)
  a_recontactar: { label: 'A recontactar', color: '#ea580c', bg: 'rgba(234,88,12,0.15)' },
  recontactado: { label: 'Recontactado', color: '#7c3aed', bg: 'rgba(124,58,237,0.15)' },
  en_conversacion: { label: 'En conversación', color: '#eab308', bg: 'rgba(234,179,8,0.15)' },
  // Solo para los prospectos: en el resto de los leads no se ofrece (ver estadosPara)
  diagnostico_enviado: { label: 'Diagnóstico enviado', color: '#6366f1', bg: 'rgba(99,102,241,0.15)' },
  derivado_asesor: { label: 'Derivado a asesor', color: '#0ea5e9', bg: 'rgba(14,165,233,0.15)' },
  // Necesita a una persona pero no es una venta: soporte, proveedores, currículums.
  // Gris a propósito: no tiene que competir visualmente con las oportunidades.
  contactado_por_fuera: { label: 'Contactado por fuera', color: '#0d9488', bg: 'rgba(13,148,136,0.15)' },
  derivado_no_comercial: { label: 'Derivado – no comercial', color: '#78716c', bg: 'rgba(120,113,108,0.15)' },
  llamada_agendada: { label: 'Llamada agendada', color: '#f97316', bg: 'rgba(249,115,22,0.15)' },
  propuesta_enviada: { label: 'Propuesta enviada', color: '#a855f7', bg: 'rgba(168,85,247,0.15)' },
  ganado: { label: 'Ganado', color: '#22c55e', bg: 'rgba(34,197,94,0.15)' },
  perdido: { label: 'Perdido', color: '#ef4444', bg: 'rgba(239,68,68,0.15)' },
  no_responde: { label: 'No responde', color: '#475569', bg: 'rgba(71,85,105,0.15)' }
};

export const QUALIFICATION_CONFIG = {
  frio: { label: 'Frío', color: '#64748b', icon: '❄️' },
  tibio: { label: 'Tibio', color: '#eab308', icon: '🌤️' },
  caliente: { label: 'Caliente', color: '#ef4444', icon: '🔥' }
};

export const SOURCE_CONFIG = {
  research: { label: 'Research', color: '#2E7DE2', bg: 'rgba(46,125,226,0.15)' },
  web_form: { label: 'Formulario Web', color: '#22c55e', bg: 'rgba(34,197,94,0.15)' },
  csv: { label: 'CSV', color: '#f97316', bg: 'rgba(249,115,22,0.15)' },
  manual: { label: 'Manual', color: '#a855f7', bg: 'rgba(168,85,247,0.15)' },
  referido: { label: 'Referido', color: '#eab308', bg: 'rgba(234,179,8,0.15)' },
  llamada: { label: 'Llamada', color: '#06b6d4', bg: 'rgba(6,182,212,0.15)' },
  evento: { label: 'Evento', color: '#ec4899', bg: 'rgba(236,72,153,0.15)' },
  dossier: { label: 'Dossier', color: '#14b8a6', bg: 'rgba(20,184,166,0.15)' },
  prospeccion: { label: 'Prospección', color: '#8b5cf6', bg: 'rgba(139,92,246,0.15)' }
};

export const STATUS_ORDER = ['frio','contactado','a_recontactar','recontactado','en_conversacion','diagnostico_enviado','derivado_asesor','llamada_agendada','propuesta_enviada','ganado','perdido','no_responde'];

/* Los estados de un lead según de dónde viene.

   Los prospectos (los que carga el agente de Prospección) siguen otro circuito:
   primer mensaje → diagnóstico en PDF → reunión → propuesta → cierre. Tienen un
   estado propio, "Diagnóstico enviado", y a la llamada la llaman "Reunión
   agendada" porque también hay reuniones presenciales. El resto de los leads,
   de este CRM y de todos los clientes, sigue viendo exactamente lo de siempre. */
const SOLO_PROSPECCION = ['diagnostico_enviado', 'a_recontactar', 'recontactado'];
const ESTADOS_PROSPECCION = ['frio', 'contactado', 'a_recontactar', 'recontactado', 'en_conversacion', 'diagnostico_enviado',
  'llamada_agendada', 'propuesta_enviada', 'ganado', 'perdido'];

export function estadoInfo(status, source) {
  const c = STATUS_CONFIG[status];
  if (!c) return { label: status || '—', color: '#64748b', bg: 'rgba(100,116,139,0.15)' };
  if (source === 'prospeccion' && status === 'llamada_agendada') return { ...c, label: 'Reunión agendada' };
  return c;
}

// Las opciones del selector de estado. Si el lead está en uno que no figura, se suma para no dejarlo en blanco
export function estadosPara(source, actual) {
  const claves = source === 'prospeccion'
    ? [...ESTADOS_PROSPECCION]
    : Object.keys(STATUS_CONFIG).filter(k => !SOLO_PROSPECCION.includes(k));
  if (actual && !claves.includes(actual)) claves.push(actual);
  return claves.map(k => [k, estadoInfo(k, source)]);
}

// Por qué se perdió un prospecto: las mismas claves que usa la API de Prospección
export const MOTIVOS_PERDIDA = {
  ya_tiene_proveedor: 'Ya tiene proveedor', no_le_interesa: 'No le interesa',
  no_respondio: 'No respondió', precio: 'Precio', otro: 'Otro',
};

/* Los dos datos del experimento de prospección: desde qué línea de WhatsApp se
   le escribió y si la charla llegó a quien decide. Mismas claves que la API. */
export const LINEAS = {
  personal: { label: 'Personal', color: '#0ea5e9' },
  nueva: { label: 'Nueva', color: '#22c55e' },
};
export const DECISOR = { si: 'Sí', no: 'No', no_se: 'No sé' };

export function formatDate(dateStr) {
  if (!dateStr) return '—';
  return new Date(dateStr).toLocaleDateString('es-AR', { day:'2-digit', month:'short', year:'numeric', hour:'2-digit', minute:'2-digit' });
}

export function formatDateShort(dateStr) {
  if (!dateStr) return '—';
  return new Date(dateStr).toLocaleDateString('es-AR', { day:'2-digit', month:'short' });
}

export function formatNumber(n) {
  if (n === null || n === undefined) return '—';
  return Number(n).toLocaleString('es-AR');
}

export function formatMoney(n) {
  if (n === null || n === undefined) return '—';
  return '$' + Number(n).toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

// El número listo para un enlace de WhatsApp: sin símbolos y con el código de país
function limpiarNumero(phone, countryCode = '54') {
  let clean = String(phone || '').replace(/[^0-9+]/g, '');
  if (!clean.startsWith('+') && !clean.startsWith(countryCode)) clean = countryCode + clean;
  return clean.replace('+', '');
}

/* El número de WhatsApp de un prospecto, listo para wa.me.

   Los prospectos se cargan con el teléfono como figura en Google ("011 4723-1234",
   "011 15 5555-1234") y el armado general dejaba el 0 y no agregaba el 9, así
   que el enlace no abría el chat. Acá se normaliza a 54 9 + característica +
   número, que es como wa.me necesita un celular argentino. Si Prospección cargó
   el número de WhatsApp aparte (`whatsapp`), manda ese tal cual. */
export function numeroWhatsAppProspecto(lead, extra = {}) {
  const propio = String(extra.whatsapp || '').replace(/\D/g, '');
  if (propio.length >= 10) return propio;
  let d = String(lead.phone || '').replace(/\D/g, '');
  if (d.startsWith('54') && d.length >= 12) d = d.slice(2);
  if (d.startsWith('9') && d.length === 11) d = d.slice(1);
  if (d.startsWith('0')) d = d.slice(1);
  if (d.length === 12) {
    const i = [2, 3, 4].find(n => d.slice(n, n + 2) === '15');
    if (i) d = d.slice(0, i) + d.slice(i + 2);
  }
  if (d.length === 10 && d.startsWith('15')) d = '11' + d.slice(2);
  if (d.length === 8) d = '11' + d;   // sin característica: AMBA, donde se buscan los prospectos
  return d.length === 10 ? '549' + d : limpiarNumero(lead.phone, '54');
}

export function buildWhatsAppUrl(phone, message, countryCode = '54') {
  return `https://wa.me/${limpiarNumero(phone, countryCode)}?text=${encodeURIComponent(message || '')}`;
}

export function applyTemplate(template, lead) {
  return template
    .replace(/\{\{nombre_negocio\}\}/g, lead.business_name || '')
    .replace(/\{\{rubro\}\}/g, lead.category || '')
    .replace(/\{\{sector\}\}/g, lead.category || '')
    .replace(/\{\{ubicacion\}\}/g, lead.city || lead.address || '')
    .replace(/\{\{telefono\}\}/g, lead.phone || '')
    .replace(/\{\{email\}\}/g, lead.email || '')
    .replace(/\{\{web\}\}/g, lead.website || '')
    .replace(/\{\{servicio\}\}/g, lead.service_interest || '');
}

export function getSourceLabel(lead) {
  // Un pedido de dossier no es una consulta con presupuesto: eso pesa más que
  // el canal. De qué anuncio vino se sigue viendo en el detalle, en los UTM.
  if (lead.source === 'dossier') return 'Dossier';
  // Anuncios en ChatGPT: van antes que lo orgánico de IA, que también llega como "chatgpt"
  if (/^(CG-|CHATGPT-ADS)/.test(lead.origen_codigo || '')) return 'ChatGPT Ads';
  if (lead.gclid || (lead.utm_source && lead.utm_source.toLowerCase() === 'google')) return 'Google Ads';
  if (lead.fbclid || (lead.utm_source && ['facebook','instagram','meta'].includes(lead.utm_source.toLowerCase()))) return 'Meta Ads';
  if (lead.source === 'web_form' && !lead.utm_source) return 'Directo';
  if (lead.source === 'research') return 'Research';
  return SOURCE_CONFIG[lead.source]?.label || lead.utm_source || lead.source || '—';
}

/* Abre la conversación con el número de quien está usando el CRM.

   En la computadora va a WhatsApp Web, que es lo que se espera. En el celular
   iba al mismo lado, y ahí no sirve: te deja en una pantalla pidiéndote escanear
   un QR, con la app instalada a un toque de distancia.

   `wa.me` es el enlace universal de WhatsApp: en el celular abre la app y en la
   compu llevaría a WhatsApp Web igual. Se usa solo en el celular porque en la
   compu mete una pantalla intermedia de "continuar al chat" que no hace falta. */
const enCelular = () => /android|iphone|ipad|ipod/i.test(navigator.userAgent || '');

export function buildWhatsAppWebUrl(phone, message, countryCode = '54') {
  const num = limpiarNumero(phone, countryCode);
  const texto = encodeURIComponent(message || '');
  return enCelular()
    ? `https://wa.me/${num}?text=${texto}`
    : `https://web.whatsapp.com/send?phone=${num}&text=${texto}`;
}
